import { render } from "./CubeJS.vue?vue&type=template&id=dcf07794&scoped=true"
import script from "./CubeJS.vue?vue&type=script&lang=js"
export * from "./CubeJS.vue?vue&type=script&lang=js"

import "./CubeJS.vue?vue&type=style&index=0&id=dcf07794&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf07794"]])

export default __exports__